import { usePricingStore } from "../stores/pricingStore";
import {
    ACTIVE_FEATURES,
    getFireBaseFeatureValue,
} from "../components/methods/getFeatureValue";
import { useBookingSettingsStore } from "../stores/bookingStore";
import { useMainStore } from "../stores/mainStore";

const submitSimpleEvent = {
    data() {
        return {
            formSubmitStatus: {
                type: Boolean,
                default: false,
            },
            pageToRedirect: "",
        };
    },
    methods: {
        async submitSimpleEventFlow() {
            const sellingTicketFeature = await
            getFireBaseFeatureValue(ACTIVE_FEATURES.SELLING_TICKET);

            const activity = this.$storage.getStorageSync("activity");
            const venues = this.$storage.getStorageSync("venues");
            const dates = this.$storage.getStorageSync("dates");
            const holidays = this.$storage.getStorageSync("holidays");
            const time = this.$storage.getStorageSync("time");
            const priceData = this.$storage.getStorageSync("priceData");
            const repeatType = this.$storage.getStorageSync("repeatType");
            const monthRepeatType = this.$storage.getStorageSync("monthRepeatType");

            const imgData = this.$storage.getStorageSync("imgData") || [];
            const activityType = this.$storage.getStorageSync("activityType") || {};
            const adminEdit = this.$storage.getStorageSync("adminEdit") || false;

            const data = {
                userId: window.currentUserId,
                activity,
                venues,
                dates,
                holidays,
                time,
                priceData,
                repeatType,
                monthRepeatType,
                imgData,
                activityType,
                adminEdit,
            };

            if (sellingTicketFeature) {
                const pricingStore = usePricingStore();
                data.priceData = pricingStore.getOldPricingFormat;
            }

            // eslint-disable-next-line no-undef
            await this.registerSimple(data)
                .then(async (response) => {
                    if (Object.keys(response.errors).length > 0) {
                        // Submitting form by admin will show all the errors that we have from backend
                        if (adminEdit) {
                            Object.keys(response.errors).forEach((errorItem) => {
                                let notificationText = "";
                                Object.keys(response.errors[errorItem])
                                    .forEach((fieldName, idx) => {
                                        if (typeof response.errors[errorItem][fieldName] === "string") {
                                            notificationText += `<b>${fieldName}</b> : `
                                            + `${response.errors[errorItem][fieldName]} <br>`;
                                        } else {
                                            notificationText += `<em>${errorItem}</em> ${idx} <br>`;
                                            Object
                                                .keys(response.errors[errorItem][fieldName])
                                                .forEach(
                                                    (nestedName) => {
                                                        notificationText += `<b>${nestedName}</b> : `
                                                    + `${response.errors[errorItem][fieldName][nestedName]} <br>`;
                                                    },
                                                );
                                        }
                                    });

                                this.$notify({
                                    type: "warn",
                                    title: `<h6>${errorItem}</h6>`,
                                    text: notificationText,
                                });
                            });
                        } else {
                            alert("Something went wrong, simple flow event may not have saved");
                            console.log(response);
                            return true;
                        }
                    }
                    if (response.success) {
                        if (sellingTicketFeature) {
                            const timeTableId = response.data.timetables.id;
                            const pricingStore = usePricingStore();
                            const bookingStore = useBookingSettingsStore();
                            try {
                                await pricingStore.saveEventPricing(timeTableId);
                            } catch (e) {
                                const mainStore = useMainStore();
                                this.editedPrice = {
                                    timetableId: "1",
                                    activityId: response.data.timetables.activity_id,
                                    termdateId: response.data.timetables.termdate_id,
                                    venueId: response.data.timetables.venue_id,
                                    freePricing: false,
                                    freeTrial: "no",
                                    price: "0",
                                    pricePerTerm: "",
                                    priceType: "per-month",
                                    errors: "",
                                };
                                mainStore.submitSimpleEventPrice(this.editedPrice);
                                console.error("Saving pricing data Failed", e);
                                alert("Saving pricing data Failed");
                            }

                            if (pricingStore.sellingTicket) {
                                try {
                                    await bookingStore.saveBookingSettings();
                                } catch (e) {
                                    console.error("Saving booking settings data Failed", e);
                                    alert("Saving booking settings data Failed");
                                }
                            }
                        }
                        this.$storage.clearStorageSync();
                        window.onbeforeunload = null;
                        window.location.href = `/management-panel/simple/${response.data.venueId}`;
                        return true;
                    }
                    return false;
                });
        },
        registerSimple(data) {
            return $.ajax({
                url: "/register-simple",
                method: "POST",
                data,
                dataType: "json",
            });
        },
    },
};

export default submitSimpleEvent;
